/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Category from '@/model/dataLayer/api/dish/Category'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import dayjs from 'dayjs'
// import Date from '.'

const entity = {
  dishId: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    }
  },
  code: {
    displayName: 'code'
  },
  name: {
    displayName: 'name'
  },
  categoryId: {
    displayName: 'labelName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname'
      }
    }
  },
  categoryTypeId: {
    displayName: 'TaxType',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: CategoryType.getList
      }
    }
  },
  totalCount: {
    displayName: 'totalMoneyCount'
  },
  totalDelivery: {
    displayName: 'totalDelivery'
  }
}

const config = {
  load: async function (filter) {
    const timespan = filter[0].dateFilter
    const startEndToday = dayjs().format('YYYY-MM-DD')
    const [fromDate, endDate] = timespan
    const dishDCacheFilter = Object.assign({}, {
      from: fromDate ?? startEndToday,
      to: endDate ?? startEndToday
    })

    const tempDCacheLog = (await hillo.get('DCache.php', Object.assign({
      op: 'showAllDCache',
      lang: GlobalSettings.getLang()
    }, dishDCacheFilter)))
      .content

    const tempDCache = tempDCacheLog.filter(item => item.amount < 0)
      .reduce(function (pv, cv) {
        if (pv[cv.id]) {
          // outDCache is negative, but the showDCache should be postive
          pv[cv.id] += parseInt(cv.amount) * -1
        } else {
          pv[cv.id] = parseInt(cv.amount) * -1
        }
        return pv
      }, {})

    const dishStatisticFilter = Object.assign({}, {
      start: fromDate ?? startEndToday,
      end: endDate ?? startEndToday
    })

    const dishStatistic = (await hillo.get('BackendData.php', Object.assign({
      op: 'dishStatistic',
      lang: GlobalSettings.getLang()
    }, dishStatisticFilter)))
      .content.map(item => {
        const temp = item

        // if (tempDCache[index] !== undefined) {
        if (tempDCache[temp.dishId]) {
          temp.totalDelivery = tempDCache[temp.dishId]
          // console.log('temp, tempDCache[temp.dishId] ', temp, tempDCache[temp.dishId])
        } else {
          temp.totalDelivery = 0
        }

        return temp
      })

    return dishStatistic
  }
}

export default IKDataEntity.ModelFactory(entity, config)
